module.exports = __webpack_public_path__ + "static/capsule-crm-1029d32eb05260b4a52ba6eebf5dc20f.png";